module.exports = __webpack_public_path__ + "static/media/trailer-1.a0b62ae3.png";